import type { TransactionsSummaryFilter } from '~domains/dashboard/entities/summary';

import { getLocalDateWithOffset } from './get-local-date-with-offset';

import type { DashboardFiltersValue } from '../model/dashboard-filters';

export function filtersToParams({
  period,
  posIds,
  merchantIds,
}: DashboardFiltersValue): TransactionsSummaryFilter {
  const { startDate, endDate } = period ?? {};

  return {
    dateTo: getLocalDateWithOffset(endDate ?? new Date()),
    dateFrom: getLocalDateWithOffset(startDate ?? new Date()),
    merchantIds,
    pointOfSalesIds: posIds,
  };
}
